module.exports = __webpack_public_path__ + "img/2025gyx-1.a8720fb4.jpeg";